import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  const { isAuth, loading } = useContext(AuthContext);

  // Enquanto a auth resolve, NÃO redireciona — só mostra o loader. Sem isto, ao
  // entrar direto em /tickets (via SSO) o app redirecionava pra /login durante o
  // loading e, ao autenticar, caía em "/" (Dashboard) → flash do dashboard.
  if (loading) {
    return <BackdropLoading />;
  }

  if (!isAuth && isPrivate) {
    return (
      <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
    );
  }

  // /sso NUNCA é curto-circuitado: mesmo já autenticado, precisa montar o
  // componente Sso p/ honrar o ?to (ex.: /crm-kanban) e re-emitir a sessão. Sem
  // esta exceção, um usuário com token existente caía sempre no "home" (/tickets
  // em embed) e o destino da aba Kanban era ignorado.
  const isSsoRoute = rest.path === "/sso";

  if (isAuth && !isPrivate && !isSsoRoute) {
    // Em embed, o "home" é a tela da aba (whaticketHome: /tickets, /crm-kanban…),
    // não o Dashboard. Fallback p/ /tickets se não houver destino guardado.
    const embed = sessionStorage.getItem("whaticketEmbed") === "1";
    const home = embed
      ? sessionStorage.getItem("whaticketHome") || "/tickets"
      : "/";
    return <Redirect to={{ pathname: home, state: { from: rest.location } }} />;
  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;
